import axiosInstance from '../axiosInterceptor/axiosInstance'

const getSeasonTeamGamesStats = async ({ orgId, teamId, seasonId }) => {
  const url = `v1/orgs/${orgId}/stats/teams/${teamId}/games`
  return axiosInstance.get(url, { params: { seasonId } })
}

export default getSeasonTeamGamesStats
